/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * CalendarInput Component
 * ---------------
 * A themed wrapper around react-datepicker.
 *
 * Features:
 * - Supports both date and datetime selection (controlled by `showTimeSelect`).
 * - Applies app-wide theme styles for consistent UI.
 * - Fully responsive input field.
 *
 * Props:
 *  - selected:     Current selected date (Date object or null).
 *  - onChange:     Callback when date changes.
 *  - placeholder:  Placeholder text for the input.
 *  - showTimeSelect: Show time picker if true.
 *
 * Usage:
 *   <CalendarInput
 *      selected={dateValue}
 *      onChange={(d) => setDateValue(d)}
 *      placeholder="Select Date"
 *      showTimeSelect={false}
 *   />
 */

import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { useTheme } from '../../theme/ThemeContext';
import 'react-datepicker/dist/react-datepicker.css';

export default function CalendarInput({ selected, onChange, placeholder, showTimeSelect }) {
  const { theme } = useTheme();

  return (
    <div style={{ width: '100%', marginTop: '0.25rem' }}>
      <ReactDatePicker
        selected={selected}
        onChange={onChange}
        placeholderText={placeholder}
        dateFormat={showTimeSelect ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd"}
        showTimeSelect={showTimeSelect}
        timeFormat="HH:mm"
        timeIntervals={1}
        className="calendar-custom-input"
        wrapperClassName="calendar-custom-wrapper"
      />

      {/* INLINE STYLING (highest priority, overrides datepicker) */}
      <style>{`
        .calendar-custom-wrapper {
          width: 100%;
        }

        .calendar-custom-input:focus {
        border-color: #86b7fe !important;
        outline: none !important;
        box-shadow: 0 0 0 0.25rem rgba(13,110,253,0.25) !important;
        }
        
        .calendar-custom-input {
          width: 100%;
          padding: 0.5rem 0.75rem;
          border: 1.5px solid ${theme.primaryLight};
          border-radius: ${theme.buttonRadius};
          font-size: 1rem;
          box-sizing: border-box;
          cursor: pointer;
        }

        .calendar-custom-input::placeholder {
          font-size: 13px !important;
          color: #8c8c8c !important;
          opacity: 1 !important;
        }

        @media (max-width: 768px) {
          .calendar-custom-input {
            font-size: 0.9rem;
            padding: 0.45rem 0.65rem;
          }
        }
      `}</style>
    </div>
  );
}